const preferenceMap = {
  email: { value: 'Email', label: 'Email' },
  phone: { value: 'Phone', label: 'Mobile SMS' },
  do_not_followup: { value: 'No automated follow-ups', label: 'No automated follow-ups' },
};

export default preferenceMap;
